import { Col, Container, Row } from '@paypalcorp/pp-react'
import React from 'react'
import ButtonFullWidth from '../../../components/ButtonFullWidth'
import { useAppDispatch } from '../../../store/hooks'
import { clearHandledError } from '../../../store/slices/handledErrorSlice'
import {
  toggleCloseGroup,
  toggleUpdateGroup,
} from '../../../store/slices/sheetsSlice'
import { Message } from '@paypalcorp/worldready-react'
import { GroupItem } from '../../../../../typings'
import { isCoverOnCreateFlowEnabled } from '../../../utils/features'
import { tracking } from '../../../lib/analytics/fpti'
import Events from '../../../lib/analytics/eventTags.js'
import serverData from '../../../utils/server-data'

interface CloseGroupFooterProps {
  groupItem: GroupItem
  onCloseGroup: (groupId: string) => void
}

export const CloseGroupFooter = ({
  groupItem,
  onCloseGroup,
}: CloseGroupFooterProps) => {
  const dispatch = useAppDispatch()

  const handleClickCancel = () => {
    tracking(
      Events.p2p_pools_edit_close_cancel_pressed({
        source: serverData.trackingParameters.externalSource,
        page_variant: 'creator',
        pool_id: groupItem.id,
      }),
    )
    dispatch(clearHandledError())
    dispatch(toggleCloseGroup())

    if (!isCoverOnCreateFlowEnabled()) {
      dispatch(toggleUpdateGroup({ focusOnCoverImageEditButton: false }))
    }
  }

  return (
    <Container form>
      <Row>
        <Col form="full">
          <ButtonFullWidth
            data-testid="closeGroupConfirmationbutton"
            onClick={() => onCloseGroup(groupItem.id)}
          >
            <Message id="update.closeGroup.confirmationButton" />
          </ButtonFullWidth>
        </Col>
      </Row>
      <Row>
        <Col form="full">
          <ButtonFullWidth
            data-testid="cancelCloseGroupButton"
            onClick={handleClickCancel}
            variant="secondary"
          >
            <Message id="update.closeGroup.cancel" />
          </ButtonFullWidth>
        </Col>
      </Row>
    </Container>
  )
}
